import { render, staticRenderFns } from "./listupt.vue?vue&type=template&id=59652fa8&"
import script from "./listupt.vue?vue&type=script&lang=js&"
export * from "./listupt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports